module.exports = __webpack_public_path__ + "h5/img/banner-bg.5d094c72.png";